export default "https://cdn-static.gokick.com/assets/42f530e1bfe0c3dccbac116cd4d83f20c9a8b744/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";